import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function Pricing() {
  return <Section id="pricing" bg="sage-light" className="border-t-4 border-sage-500" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <div className="text-center mb-10" data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-sage-900" data-id="element-114">
            Toma el control total de tu suplementación hoy mismo
          </h2>
          <p className="text-xl text-charcoal-light" data-id="element-115">
            por un precio único de lanzamiento.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border border-sage-200 overflow-hidden max-w-2xl mx-auto" data-id="element-116">
          <div className="bg-sage-700 p-6 text-center" data-id="element-117">
            <h3 className="text-2xl font-bold text-white" data-id="element-118">Acceso Inmediato</h3>
          </div>

          <div className="p-8 md:p-12" data-id="element-119">
            <div className="flex flex-col items-center mb-8" data-id="element-120">
              <span className="text-sm font-bold text-terracotta uppercase tracking-wider mb-2 bg-terracotta/10 px-3 py-1 rounded-full" data-id="element-121">
                Precio único de lanzamiento
              </span>
              <div className="flex items-start justify-center" data-id="element-122">
                <span className="text-3xl font-bold text-charcoal mt-2" data-id="element-123">$</span>
                <span className="text-7xl font-bold text-charcoal tracking-tighter" data-id="element-124">
                  7.00
                </span>
                <span className="text-xl font-bold text-charcoal-light mt-8 ml-2" data-id="element-125">
                  USD
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-126">
              <li className="flex items-start gap-3" data-id="element-127">
                <Check className="w-6 h-6 text-sage-600 flex-shrink-0" data-id="element-128" />
                <span className="text-lg text-charcoal font-medium" data-id="element-129">
                  Consigue la <strong data-id="element-130">"Guía Inteligente de Suplementos"</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-131">
                <Check className="w-6 h-6 text-sage-600 flex-shrink-0" data-id="element-132" />
                <div className="flex flex-col" data-id="element-133">
                  <span className="text-lg text-charcoal font-medium" data-id="element-134">
                    <strong data-id="element-135">+ Bono #2</strong> — Checklist de suplementos
                    orgánicos
                  </span>
                  <span className="text-sm mt-1" data-id="element-136">
                    <span className="line-through text-charcoal-light" data-id="element-137">
                      $10.00 USD
                    </span>
                    <span className="ml-2 font-bold text-sage-700 bg-sage-100 px-2 py-0.5 rounded-full text-xs uppercase tracking-wide" data-id="element-138">
                      Gratis con esta oferta
                    </span>
                  </span>
                </div>
              </li>
            </ul>

            <div className="text-center" data-id="element-139">
              <Button className="w-full py-5 text-xl" data-id="element-140">
                QUIERO MI GUÍA AHORA
              </Button>
            </div>

            <p className="text-sm text-center text-charcoal-light mt-8 italic" data-id="element-141">
              (Y recuerda: Al finalizar tu lectura, tendrás un enlace directo
              para contactarme si deseas un análisis personalizado de tu caso y
              recomendación de marcas específicas).
            </p>
          </div>
        </div>
      </div>
    </Section>;
}